@if(statusService.showTotalBreakTime) {
<div class="ongoing-call-mini" [hidden]="campaignService.showCallDetails">
  <span class="slider-btn">
    <span class="blink-soft"></span>
    <span class="timer widthTotalBreakTime">Total Break Time : {{ statusService.totalBreakDuration}}</span>
  </span>
</div>
}

<div *ngIf="telephonyState.onCall && !navService.getSideNav('right')" [hidden]="campaignService.showCallDetails">
<!-- <div> -->
  <div class="ongoing-call-mini" [ngClass]="{'collapsed': !isMiniFloater}">
    <span class="slider-btn" (click)="toggleMiniFloater()">
      <span class="blink-soft"
        [ngClass]="{'on-call': telephonyState.onCall, 'call-ended': telephonyState.isCallEnded && !telephonyState.isCallDisposed}"></span>
      <span class="timer">{{ callService.stringTimer}}</span>
    </span>
  </div>
  <div cdkDrag class="ongoing-call-module-wrapper"
    style="cursor: move; width: auto; position: fixed; left: 450px; top: 68px; z-index: 100;"
    [cdkDragFreeDragPosition]="dragPosition" *ngIf="!isMiniFloater">
    <div class="ongoing-call-module "
      [ngClass]="{ '--has-textarea': campaignService.showOtherReasonTextBox, 'ongoing-call-module--collapsed': !(telephonyState.isCallEnded && !telephonyState.isCallDisposed && isFloaterCollapsed)}">
    <!-- <div class="ongoing-call-module "> -->
      <div class="ongoing-call-module__content">
        <div class="info">
          <span>{{campaignService.lead?.CustomerInfo?.FirstName}}
            {{campaignService.lead?.CustomerInfo?.LastName}}</span>
          <p class="call-timer--ongoing-call">{{telephonyState.btn}} . {{ callService.stringTimer }}</p>
        </div>
        <div class="ongoing-call-module__actions">
          <div (click)="navService.setSideNav(!navService.getSideNav('right'), 'right')" data-tooltip="Dialpad"
            data-tooltip-conf="bottom">
            <i class="fa-light">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.420898" y="0.84375" width="4" height="4" rx="2" />
                <rect x="0.420898" y="6.65625" width="4" height="4" rx="2" />
                <rect x="6.0791" y="0.84375" width="4" height="4" rx="2" />
                <rect x="6.0791" y="6.65625" width="4" height="4" rx="2" />
                <rect x="6.0791" y="12.1562" width="4" height="4" rx="2" />
                <rect x="11.5791" y="0.84375" width="4" height="4" rx="2" />
                <rect x="11.5791" y="6.65625" width="4" height="4" rx="2" />
              </svg>
            </i>
          </div>
          <div [ngClass]="{'disabled' : !dialpadService.muteUnmuteEnabled }" (click)="muteCall()"
            [attr.data-tooltip]="!telephonyState.isMuted ? 'Mute' : 'Unmute'" data-tooltip-conf="bottom">
            <i [attr.data-interaction]="campaignService.customerCallSid + ' - mute call'"
              *ngIf="!telephonyState.isMuted" class="fa-light fa-microphone-lines"></i>
            <i [attr.data-interaction]="campaignService.customerCallSid + ' - un-mute call'"
              *ngIf="telephonyState.isMuted" class="fa-light fa-microphone-lines-slash"></i>
          </div>
          <div [ngClass]="{'disabled' : !dialpadService.holdResumeEnabled }" (click)="holdCall()"
            [attr.data-tooltip]="!telephonyState.onHold ? 'Hold' : 'Resumed'" data-tooltip-conf="bottom">
            <i [attr.data-interaction]="campaignService.customerCallSid + ' - hold call'" *ngIf="!telephonyState.onHold"
              class="fa-light fa-pause"></i>
            <i [attr.data-interaction]="campaignService.customerCallSid + ' - resume call'"
              *ngIf="telephonyState.onHold" class="fa-light fa-play"></i>
          </div>
          <!-- <div [ngClass]="{'disabled' : !dialpadService.consultEnabled }"
          (click)="navService.setSideNav(!navService.getSideNav('right'), 'right')">
          <i class="fa-light fa-user-plus"></i>
                </div>
                <div [ngClass]="{'disabled' : !dialpadService.transferEnabled }"
          (click)="navService.setSideNav(!navService.getSideNav('right'), 'right')" data-tooltip="Transfer Call"
          data-tooltip-conf="bottom">
          <i class="fa-light fa-arrow-right-from-bracket"></i>
                </div> -->
          <div [attr.data-interaction]="campaignService.customerCallSid + ' - end call'" (click)="hangupCall()"
            [ngClass]="{'disabled' : telephonyState.isCallEnded }" data-tooltip="Hang Up" data-tooltip-conf="bottom">
            <i [attr.data-interaction]="campaignService.customerCallSid + ' - end call'"
              class="hang-up fa-solid fa-phone-hangup"></i>
          </div>
          <div class="icons-group icons-group--ongoing-call">
            <div class="icons-group__icons">
              <i class="icon-1" data-tooltip="Reset Position" data-tooltip-conf="bottom" (click)="resetPosition()">
                <i class="fa-light fa-arrow-rotate-left"></i>
              </i>
              <div class="icon-2" data-toggle="call-action" (click)="toggleFloaterCollapse()"
                *ngIf="telephonyState.isCallEnded && !telephonyState.isCallDisposed">
                <i class="mr-8 fa-light"
                  [ngClass]="{'fa-angle-down': isFloaterCollapsed, 'fa-angle-up': !isFloaterCollapsed}"></i>
              </div>
              <i class="fa-light fa-xmark icon-3" (click)="toggleMiniFloater()"></i>
            </div>
          </div>
          <!-- <div data-toggle="call-action"><i class="fa-solid fa-grip-dots-vertical"></i></div> -->
        </div>
      </div>

      <form [formGroup]="campaignService.dispositionForm" action="" class="ongoing-call-module__form">
        <div class="flex-group-call">
          <div class="single-input-field-wrapper">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list dropdown-list--with-bg">
                <label for="disposition-grp" class="dropdown-list__label">Disposition group</label>
                <f-dropdown [filter]="true" placeholder="Select Disposition Group"
                  [options]="campaignService.dispositionGroups" formControlName="dispositionGroup" optionLabel="Group"
                  optionValue="Group" [ngStyle]="{ width: '163px' }" [style]="{ width: '163px' }">
                </f-dropdown>
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('dispositionGroup', campaignService.dispositionForm)">
              Please provide group.
            </div>
          </div>
          <div class="single-input-field-wrapper">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list dropdown-list--with-bg">
                <label for="disposition" class="dropdown-list__label">Disposition</label>
                <!-- <span class="dropdown-list__opt-select"> -->
                <f-dropdown [filter]="true" placeholder="Select Disposition" [options]="campaignService.dispositions"
                  formControlName="disposition" optionLabel="Name" optionValue="Id" [ngStyle]="{ width: '195px' }"
                  [style]="{ width: '195px' }">
                </f-dropdown>
                <!-- </span> -->
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('disposition', campaignService.dispositionForm)">
              Please provide disposition.
            </div>
          </div>
          <div *ngIf="campaignService.showReasonDropDown" class="single-input-field-wrapper">
          <!-- <div class="single-input-field-wrapper"> -->
            <div class="dropdown-list-wrapper dropdown-list-wrapper--inverted">
              <div class="dropdown-list dropdown-list--with-bg call-dropdown call-dropdown--addons">
                <label for="disposition" class="dropdown-list__label">Reasons</label>
                <!-- <span class="dropdown-list__opt-select"> -->
                <span class="call-dropdown__opt-select">
                  <f-multiSelect [filter]="true" placeholder="Select Reasons" [options]="campaignService.reasons"
                    formControlName="reasons" optionLabel="label" optionValue="value" [ngStyle]="{ width: '195px' }"
                    [style]="{ width: '195px' }">
                  </f-multiSelect>
                </span>
                <!-- </span> -->
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('reasons', campaignService.dispositionForm)">
              Please provide reasons.
            </div>
          </div>
          <div class="single-input-field-wrapper" *ngIf="campaignService.isPK_Call">
            <div class="dropdown-list-wrapper dropdown-list-wrapper--inverted">
              <div class="dropdown-list dropdown-list--with-bg call-dropdown call-dropdown--addons">
                <label for="disposition" class="dropdown-list__label">Addons</label>
                <span class="call-dropdown__opt-select">
                  <f-multiSelect [filter]="true" [options]="addons"
                    placeholder="Select Addons" display="chip" optionLabel="Name" optionValue="Name"
                    [ngStyle]="{ width: '195px' }" [style]="{ width: '195px' }" [(ngModel)]="campaignService.addons"
                    [ngModelOptions]="{ standalone: true }">
                  </f-multiSelect>
                </span>
                <!-- </span> -->
              </div>
            </div>
          </div>
          <a (click)="disposeCall()" class="single-button--with-bg single-button--with-bg-danger">Dispose</a>
        </div>
        @if(campaignService.dispositionCallbackSelection === 'Callback Scheduled') {
        <div class="flex-group">
          <div class="single-input-field-wrapper">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list dropdown-list--with-bg">
                <label for="callbackTimezone" class="dropdown-list__label">Time Zone</label>
                <f-dropdown [filter]="true" placeholder="Select Time Zone" [options]="callbackConfig.timeZones"
                  formControlName="callbackTimezone" optionLabel="name" optionValue="value" [ngStyle]="{ width: '163px' }"
                  [style]="{ width: '163px' }" (onChange)="updateMinDate($event.value)">
                </f-dropdown>
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('callbackTimezone', campaignService.dispositionForm)">
              Please select timezone.
            </div>
          </div>
          <div class="single-input-field-wrapper">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list dropdown-list--with-bg">
                <label for="callbackDate" class="dropdown-list__label">Callback Date</label>
                <p-calendar placeholder="Callback Date" formControlName="callbackDate" [minDate]="callbackConfig.minDate">
                </p-calendar>
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('callbackDate', campaignService.dispositionForm)">
              Please provide callback time.
            </div>
          </div>
          <div class="single-input-field-wrapper small-dropdown">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list dropdown-list--with-bg">
                <label for="callbackHour" class="dropdown-list__label">Hour</label>
                <f-dropdown formControlName="callbackHour" placeholder="Select hour" [options]="callbackConfig.hours"
                  [style]="{ wwidth: '100%' }">
                </f-dropdown>
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('callbackHour', campaignService.dispositionForm)">
              Select hours.
            </div>
          </div>
          <div class="single-input-field-wrapper small-dropdown">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list dropdown-list--with-bg">
                <label for="callbackMins" class="dropdown-list__label">Minutes</label>
                <f-dropdown formControlName="callbackMins" placeholder="Select Mins" [options]="callbackConfig.minutes"
                  [style]="{ width: '100%' }">
                </f-dropdown>
              </div>
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="this.campaignService.checkFieldValidation('callbackMins', campaignService.dispositionForm)">
              Select mins.
            </div>
          </div>
        </div>
        }

        <div *ngIf="campaignService.showOtherReasonTextBox" class="other-reason">
          <textarea formControlName="otherReasons"></textarea>
          <div *ngIf="this.campaignService.checkFieldValidation('otherReasons', campaignService.dispositionForm)"
            class="validation validation--error validation--push-bottom">
            Please provide other reason.
          </div>
        </div>
      </form>
    </div>
  </div>
</div>